import React from 'react';
import { MOBILE_IMAGE, DESKTOP_IMAGE } from '../config';
import './style.scss';

const TrustedBy = ({ company }) => (
    <li>
        <picture>
            <source media={MOBILE_IMAGE} srcSet={company.mobile}/>
            <source media={DESKTOP_IMAGE} srcSet={company.desktop}/>
            <img src={company.src} alt={company.alt}/>
        </picture>
    </li>
);

export default TrustedBy;
